import { Component, OnInit, ViewChild, Output, EventEmitter, TemplateRef } from '@angular/core';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Dateconfig } from 'src/app/configuration/dateconfig/dateconfig';
import { ToastrService } from 'ngx-toastr';
import { SimpleModalService } from 'ngx-simple-modal';
import { ConfirmComponent } from '../../confirm/confirm';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
import { Router, ActivatedRoute } from '@angular/router';
import { RentbillService } from 'src/app/_services/rentbill/rentbill.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SaleBillModel } from 'src/app/Entites/ExportToExcel/SaleBillModel';
import { TableexcelService } from 'src/app/_services/tableexcel.service';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';
import { CommonService } from 'src/app/common/common.service';
import { LogMessages } from 'src/app/common/LogMessages';

@Component({
  selector: 'app-allrentinvoice',
  templateUrl: './allrentinvoice.component.html',
  styleUrls: ['./allrentinvoice.component.css'],
  providers: [CustomLoaderCComponent, ToastrService]

})
export class AllrentinvoiceComponent implements OnInit {
    public breadcrumb: any;
  options = {
    close: false,
    expand: true,
    minimize: true,
    reload: false
  };
  columns: any = [];
  rows: any;
  name = 'Angular';
  model: any = {};
  value: any;
  loadingIndicator: true;
  selected = [];
  temp = [];
  temp2 = [];
  confirmResult = null;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @Output() closeModalEvent = new EventEmitter<boolean>();
  @ViewChild(DatatableComponent) table: DatatableComponent;
  /**
     *
     * @param NgbModal      modal
     */
  constructor(

    private spinner: CustomLoaderCComponent,
    private dateconfig: Dateconfig,
    private modalpop: NgbModal,
    private toastrService: ToastrService,
    private router: ActivatedRoute,
    private routernav: Router,
    private SimpleModalService: SimpleModalService,
    private billService: RentbillService,
    private exportToexcelService: TableexcelService,
    private commonService: CommonService
  ) { }

  UserTypeDescription
  ngOnInit() {
    this.UserTypeDescription = localStorage.getItem( LocalStorageConstants.USER_TYPE_DESCRIPTION);

    if (!this.commonService.CheckUserAccess('all-rent-repair-bills', this.UserTypeDescription)) {
            console.warn(LogMessages.NO_ACCESS);
      this.routernav.navigate(['/dashboard/newdashboard']);
    }

    this.breadcrumb = {
      'mainlabel': 'All Rent/Repair Bills',
    };
    this.getallbill();
  }

  getallbill() {
    this.spinner.showSpinner();
    this.billService.GetAllBill().subscribe(Response => {
      this.rows = Response;
      this.temp2 = Response;
      this.temp = Response;
      this.spinner.hideSpinner();


    });
  }
  
  encrypt(id) {
    return btoa(id);
  }
  showConfirm(id) {
    this.SimpleModalService.addModal(ConfirmComponent, {
      title: 'Confirmation',
      message: 'Are you sure to delete this record ?'
    })
      .subscribe((isConfirmed) => {
        // Get modal result
        this.confirmResult = isConfirmed;

        if (isConfirmed) {
          this.spinner.showSpinner();


          this.billService.delete(id).subscribe(
            (res: any) => {

              if (res.result == 1) {
                this.ngOnInit();


                this.toastrService.success(res.userMessage, '', { timeOut: 1000, closeButton: true });

              }
              else {
                this.spinner.hideSpinner();
                this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });

              }

            },
            err => {
              this.spinner.hideSpinner();

              this.toastrService.error('server is down', '', { timeOut: 3000, closeButton: true });

            }
          )
        }
      });
  }
  updateFilter(event) {

    const val = event.target.value.toLowerCase();
    this.rows = [...this.temp2]; // and here you have to initialize it with your data
    this.temp = [...this.rows];
    // filter our data
    const temp = this.rows.filter(function (d) {
      return d.displayBillNumber.toLowerCase().indexOf(val) !== -1 ||
        d.customerFullName.toLowerCase().indexOf(val) !== -1 ||
        d.customerContact.toLowerCase().indexOf(val) !== -1 ||
        d.totalAmountIncGST == event.target.value ||
        d.rentBillDeposit == event.target.value ||
        d.totalpaidAmount == event.target.value ||
        d.balanceAmount == event.target.value ||
        d.totalAmountIncGST == event.target.value ||
        d.billType.toLowerCase().indexOf(val) !== -1 ||



        //this.dateconfig.getshortdate(d.billDate)==event.target.value||

        !val;
    });
    this.rows = temp;
  }

  GetExcelRentBillsData(): void {
     var excelData = [];
    for (var i = 0; i < this.rows.length; i++) {
      var rentBillModel = new SaleBillModel();
      rentBillModel.SrNo = i + 1;
      rentBillModel.BillDate = this.dateconfig.getshortdate(this.rows[i].billDate);
      rentBillModel.BillNo = this.rows[i].displayBillNumber;
      rentBillModel.CustomerName = this.rows[i].customerFullName;
      rentBillModel.ContactNumber = this.rows[i].customerContact;
      rentBillModel.TotalAmount = Math.round(this.rows[i].totalAmountIncGST);
      rentBillModel.BalanceAmount = Math.round(this.rows[i].balanceAmount);
      rentBillModel.BillType = this.rows[i].billType + (this.rows[i].isIgstBill ? " - IGST" : "");
      rentBillModel.PaidAmount = this.rows[i].totalpaidAmount;
      rentBillModel.Remark = this.rows[i].remark;
      rentBillModel.Deposit = this.rows[i].rentBillDeposit;
      excelData.push(rentBillModel);
    }

    this.exportToexcelService.exportAsExcelFile(excelData, "Rent-Bills-" + this.dateconfig.getshortdate(Date.now()));

  }
}
